<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-camera-home'}"
	[headerText]="data.trainingRoom.name + (T.CAMERA_SELECTION_DIALOG_HEADER_SUFFIX | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-admin-settings-scroll-entries-con
			[getScrollEntryText]="getCameraName.bind(this)"
			(removeEntryEmitter)="removeCamera($event)"
			[scrollEntries]="data?.trainingRoom?.availableCameraIds"
		>
			<mat-form-field color="accent" style="width: 100%; justify-items: center">
				<mat-label>
					{{ T.CONFIGURATION_EDITOR_TRAINING_ROOM_AVAILABLE_CAMERAS | translate }}
				</mat-label>
				<mat-select
					(ngModelChange)="addCamera($event, data.trainingRoom.availableCameraIds)"
					[(ngModel)]="selectedCameraId"
					style="width: 100%"
				>
					@for (camera of unassignedCameras; track camera) {
						<mat-option [value]="camera.id">
							{{ camera.name }}
						</mat-option>
					}
					<mat-option [value]="null">
						{{ T.CONFIGURATION_EDITOR_TRAININGROOM_NO_CAMERA | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</sim-admin-settings-scroll-entries-con>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [color]="'warn'" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CANCEL" />

		<sim-button
			(onClick)="ok()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.CONFIGURATION_EDITOR_CAMERA_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
